module.exports = __webpack_public_path__ + "img/kommune-2021.93d27f15.svg";